<mat-card *ngIf="!isLoggedIn"> <mat-card-content>log in please</mat-card-content></mat-card>

<div *ngIf="isLoggedIn">
  <div class="grid-top">
    <!-- selecting -->
    <ng-container *ngIf="!connectedCharacter">
      <mat-card class="card">
        <mat-card-header>
          <mat-card-title>user</mat-card-title>
          <mat-card-subtitle>{{ claims.sub }}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <mat-form-field appearance="outline">
            <mat-label>name</mat-label>
            <input matInput [(ngModel)]="createName" />
            <mat-hint>max 20 characters</mat-hint>
          </mat-form-field>
        </mat-card-content>
        <mat-card-actions>
          <button mat-raised-button color="accent" (click)="createCharacter()">create character</button>
        </mat-card-actions>
      </mat-card>
      <div class="column-spacer"></div>

      <mat-card *ngIf="characters.length == 0" class="card spinner-card"
        ><mat-progress-spinner mode="indeterminate" class="spinner"></mat-progress-spinner>
      </mat-card>

      <mat-card *ngFor="let character of characters" class="card">
        <mat-card-header>
          <mat-card-title>{{ character.name }}</mat-card-title>
          <mat-card-subtitle>{{ character.characterId }}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>{{ character.createdAt }}</mat-card-content>
        <mat-card-actions>
          <button mat-raised-button color="primary" (click)="connect(character)" class="action-btn">connect</button>
          <button mat-raised-button color="warn" (click)="deleteCharacter(character)" class="action-btn">delete</button>
        </mat-card-actions>
      </mat-card>
    </ng-container>

    <!-- connected -->
    <ng-container *ngIf="connectedCharacter">
      <mat-card class="card">
        <mat-card-header>
          <mat-card-title>user</mat-card-title>
          <mat-card-subtitle>{{ claims.sub }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>

      <mat-card class="card">
        <mat-card-header>
          <mat-card-title>character - {{ connectedCharacter.name }}</mat-card-title>
          <mat-card-subtitle>{{ connectedCharacter.characterId }}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
          <button mat-raised-button color="accent" (click)="disconnect()">disconnect</button>
        </mat-card-actions>
      </mat-card>

      <app-room-select
        [ws]="ws"
        [connectedCharacter]="connectedCharacter"
        [joinedRoom]="joinedRoom"
        (setRoom)="setRoom($event)"
        class="room-select"
      ></app-room-select>

      <app-chat
        [ws]="ws"
        [connectedCharacter]="connectedCharacter"
        [joinedRoom]="joinedRoom"
        class="chat-comp"
      ></app-chat>
    </ng-container>
  </div>
</div>
